import React, { useState } from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { Divider, Grid, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

type Anchor = 'top' | 'left' | 'bottom' | 'right';

type SwipeableDrawerFormProps = {
  anchor?: Anchor;
  formComponent?: React.ReactNode;
  openForm?: boolean;
  onClose?: () => void;
  title?: string;
  isMobile?:boolean
};

const SwipeableDrawerForm: React.FC<SwipeableDrawerFormProps> = ({
  anchor = 'left',
  formComponent,
  openForm = false,
  onClose,
  title = 'Drawer Form',
  isMobile=false
}) => {
  const [open, setOpen] = React.useState(openForm);
  const [isMaximized, setIsMaximized] = useState(false);

  React.useEffect(() => {
    setOpen(openForm);
  }, [openForm]);

  const toggleDrawer = (isOpen: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setOpen(isOpen);
    if (!isOpen && onClose) {onClose()
      setIsMaximized(false);
    };
  };

  const handleMaximize = () => {
    setIsMaximized((prev) => !prev);
  };

  return (
    <SwipeableDrawer
      anchor={anchor}
      open={open}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      PaperProps={{
        sx: {
          width: isMaximized ? '100vw' : anchor === 'top' || anchor === 'bottom' ? 'auto' : isMobile?'100%':450,
          //height: isMaximized ? '100vh' : 'auto',
          maxWidth: isMaximized ? '100%' : 'none',
          transition: 'width 0.3s, height 0.3s',
        },
      }}
    >
      {/* Header Section */}
      <Box sx={{ padding: 2 }}>
        <Grid container alignItems="center" justifyContent="space-between" sx={{ paddingBottom: 1, backgroundColor: '#499426', borderRadius: 2 }}>
          <Typography sx={{ fontSize: '1rem', paddingLeft: 2, paddingTop: 1, color: '#fff' }} fontWeight="bold">
            {title}
          </Typography>
          <Grid item>
            {/* Maximize/Minimize Button */}
            <IconButton onClick={handleMaximize}>
              {isMaximized ? <FullscreenExitIcon sx={{ color: '#fff' }} /> : <FullscreenIcon sx={{ color: '#fff' }} />}
            </IconButton>
            {/* Close Button */}
            <IconButton onClick={() => toggleDrawer(false)({} as React.MouseEvent)}>
              <CloseIcon sx={{ color: '#fff' }} />
            </IconButton>
          </Grid>
        </Grid>
        <Divider />
        {/* Form Section */}
        <Box role="presentation">{formComponent}</Box>
      </Box>
    </SwipeableDrawer>
  );
};

export default SwipeableDrawerForm;
